// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RouteModal_modalOverlay__GjlA\\+ {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.RouteModal_modal__nHjZT {
  background: #fff;
  border-radius: 0.5rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  width: 90%;
  max-width: 500px;
  max-height: 90vh;           /* ограничиваем высоту окна */
  display: flex;
  flex-direction: column;
  overflow: hidden;           /* прокрутка внутри .modalBody */
}

.RouteModal_modalHeader__eT6Rz {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem;
  border-bottom: 1px solid #e5e5e5;
}

.RouteModal_modalHeader__eT6Rz h3 {
  margin: 0;
  font-size: 1.25rem;
}

.RouteModal_modalHeader__eT6Rz button {
  background: transparent;
  border: none;
  font-size: 1.25rem;
  cursor: pointer;
}

.RouteModal_modalBody__MUd6v {
  padding: 0.5rem;             /* чуть меньше отступы */
  display: grid;
  grid-gap: 0.5rem;
  overflow-y: auto;            /* вертикальная прокрутка */
  max-height: calc(90vh - 5rem); /* учёт header + footer */
}

.RouteModal_modalBody__MUd6v label {
  display: flex;
  flex-direction: column;
  font-size: 0.875rem;
}

.RouteModal_modalBody__MUd6v input[type="text"],
.RouteModal_modalBody__MUd6v input[type="date"],
.RouteModal_modalBody__MUd6v input[type="number"],
.RouteModal_modalBody__MUd6v input {
  margin-top: 0.25rem;
  padding: 0.4rem;             /* уменьшено для компактности */
  border: 1px solid #ccc;
  border-radius: 0.25rem;
  font-size: 0.9rem;
  width: 100%;
  box-sizing: border-box;
}

.RouteModal_checkboxLabel__JZgWR {
  display: flex;
  align-items: center;
  font-size: 0.875rem;
}

.RouteModal_checkboxLabel__JZgWR input {
  margin-right: 0.5rem;
}

.RouteModal_modalFooter__S95CR {
  display: flex;
  justify-content: center;     /* выравнивание по центру */
  padding: 0.5rem;             /* чуть меньше отступы */
  border-top: 1px solid #e5e5e5;
}

.RouteModal_modalFooter__S95CR button {
  flex: 1 1;
  max-width: 120px;            /* одинаковая максимальная ширина */
  padding: 0.5rem;
  border: none;
  border-radius: 0.25rem;
  font-size: 0.9rem;
  cursor: pointer;
  margin: 0 0.25rem;           /* симметричные отступы */
}

.RouteModal_modalFooter__S95CR button:first-child {
  background: #f5f5f5;
}

.RouteModal_modalFooter__S95CR button:last-child {
  background: #007bff;
  color: #fff;
}

.RouteModal_modalFooter__S95CR button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.RouteModal_error__IzwrU {
  color: #e00;
  font-size: 0.875rem;
  margin-top: 0.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/modules/Admin/RouteBuilder/RouteModal.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,yCAAyC;EACzC,UAAU;EACV,gBAAgB;EAChB,gBAAgB,YAAY,6BAA6B;EACzD,aAAa;EACb,sBAAsB;EACtB,gBAAgB,YAAY,gCAAgC;AAC9D;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe,cAAc,wBAAwB;EACrD,aAAa;EACb,gBAAgB;EAChB,gBAAgB,aAAa,2BAA2B;EACxD,6BAA6B,EAAE,yBAAyB;AAC1D;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;;;;EAIE,mBAAmB;EACnB,eAAe,cAAc,+BAA+B;EAC5D,sBAAsB;EACtB,sBAAsB;EACtB,iBAAiB;EACjB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,uBAAuB,MAAM,2BAA2B;EACxD,eAAe,cAAc,wBAAwB;EACrD,6BAA6B;AAC/B;;AAEA;EACE,SAAO;EACP,gBAAgB,aAAa,mCAAmC;EAChE,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,iBAAiB,YAAY,yBAAyB;AACxD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":[".modalOverlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100vw;\r\n  height: 100vh;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1000;\r\n}\r\n\r\n.modal {\r\n  background: #fff;\r\n  border-radius: 0.5rem;\r\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\r\n  width: 90%;\r\n  max-width: 500px;\r\n  max-height: 90vh;           /* ограничиваем высоту окна */\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;           /* прокрутка внутри .modalBody */\r\n}\r\n\r\n.modalHeader {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 0.75rem;\r\n  border-bottom: 1px solid #e5e5e5;\r\n}\r\n\r\n.modalHeader h3 {\r\n  margin: 0;\r\n  font-size: 1.25rem;\r\n}\r\n\r\n.modalHeader button {\r\n  background: transparent;\r\n  border: none;\r\n  font-size: 1.25rem;\r\n  cursor: pointer;\r\n}\r\n\r\n.modalBody {\r\n  padding: 0.5rem;             /* чуть меньше отступы */\r\n  display: grid;\r\n  grid-gap: 0.5rem;\r\n  overflow-y: auto;            /* вертикальная прокрутка */\r\n  max-height: calc(90vh - 5rem); /* учёт header + footer */\r\n}\r\n\r\n.modalBody label {\r\n  display: flex;\r\n  flex-direction: column;\r\n  font-size: 0.875rem;\r\n}\r\n\r\n.modalBody input[type=\"text\"],\r\n.modalBody input[type=\"date\"],\r\n.modalBody input[type=\"number\"],\r\n.modalBody input {\r\n  margin-top: 0.25rem;\r\n  padding: 0.4rem;             /* уменьшено для компактности */\r\n  border: 1px solid #ccc;\r\n  border-radius: 0.25rem;\r\n  font-size: 0.9rem;\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.checkboxLabel {\r\n  display: flex;\r\n  align-items: center;\r\n  font-size: 0.875rem;\r\n}\r\n\r\n.checkboxLabel input {\r\n  margin-right: 0.5rem;\r\n}\r\n\r\n.modalFooter {\r\n  display: flex;\r\n  justify-content: center;     /* выравнивание по центру */\r\n  padding: 0.5rem;             /* чуть меньше отступы */\r\n  border-top: 1px solid #e5e5e5;\r\n}\r\n\r\n.modalFooter button {\r\n  flex: 1;\r\n  max-width: 120px;            /* одинаковая максимальная ширина */\r\n  padding: 0.5rem;\r\n  border: none;\r\n  border-radius: 0.25rem;\r\n  font-size: 0.9rem;\r\n  cursor: pointer;\r\n  margin: 0 0.25rem;           /* симметричные отступы */\r\n}\r\n\r\n.modalFooter button:first-child {\r\n  background: #f5f5f5;\r\n}\r\n\r\n.modalFooter button:last-child {\r\n  background: #007bff;\r\n  color: #fff;\r\n}\r\n\r\n.modalFooter button:disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.error {\r\n  color: #e00;\r\n  font-size: 0.875rem;\r\n  margin-top: 0.5rem;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalOverlay": `RouteModal_modalOverlay__GjlA+`,
	"modal": `RouteModal_modal__nHjZT`,
	"modalHeader": `RouteModal_modalHeader__eT6Rz`,
	"modalBody": `RouteModal_modalBody__MUd6v`,
	"checkboxLabel": `RouteModal_checkboxLabel__JZgWR`,
	"modalFooter": `RouteModal_modalFooter__S95CR`,
	"error": `RouteModal_error__IzwrU`
};
export default ___CSS_LOADER_EXPORT___;
